// placeholder - TBD 
import React, { useState } from "react";
import { 
  Grid,
  ToggleButton,
  Typography,
  Switch
} from "@mui/material";
import FilterAltIcon from '@mui/icons-material/FilterAlt';

import { useAppContext } from "../../context/AppContext";
import { t } from "i18next";

export default function DashboardAssignedByMeToolbar({
  setFilterSelection,
  isSelectingEnabled,
  setIsSelectingEnabled
}) {
  const { store } = useAppContext();
  const [filterSelected, setFilterSelected] = useState(false);
  const handleFilterSelection = () => {
    return;
  }

  return (
    <React.Fragment>
      {/* <Grid item sx={{ marginRight: 2 }}>
        <ToggleButton 
          selected={filterSelected}
          onChange={() => {
            setFilterSelected(!filterSelected);
          }}
        >
          <FilterAltIcon/>
        </ToggleButton>
      </Grid> */}
      <Grid item sx={{ marginRight: 2 }}>
        <Typography component="label" variant="body2">
          {t("BulkActions")}
        </Typography>
        <Switch
          checked={isSelectingEnabled}
          onChange={(e) => setIsSelectingEnabled(e.target.checked)}
          color="primary"
        />
      </Grid>
    </React.Fragment>
  );
}
